import 'reflect-metadata';
import { Service } from 'typedi';
import type { CardTypeStrategyData } from '../../types/card-strategy-data.type';
import type { SearchApiDocument } from '../../../../api/model/response/documents/SearchResult';
import { StrategyBuilder } from '../../StrategyBuilder';
import { CardStrategyService } from '../../CardStrategyService';

@Service({ id: 'prsmPublicCardStrategyService' })
export class PrsmPublicCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {
  build(details: CardTypeStrategyData): CardStrategyService {
      return new PrsmPublicCardStrategyService(details);
  }
}

export class PrsmPublicCardStrategyService extends CardStrategyService {
  details;
  constructor(details: CardTypeStrategyData) {
      super();
      this.details = details;
  }

  makeCard(doc: SearchApiDocument): string {
      if (this.details.params.tabType === 'prsm/products') {
        return 'uiaas-search-result-product-prsm';
      } else {
        return 'uiaas-search-result-basic-prsm';
      }
  }

  getCardProps(
    doc: SearchApiDocument,
    params: Record<string, string>
  ): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
